export const AUTH_LOGIN_START = "AUTH_LOGIN_START";
export const AUTH_LOGIN_FAIL = "AUTH_LOGIN_FAIL";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";

export const AUTH_CHECK = "AUTH_CHECK";
export const AUTH_LOADING = "AUTH_LOADING";

export const AUTH_GET_USER_START = "AUTH_GET_USER_START";
export const AUTH_GET_USER_SUCCESS = "AUTH_GET_USER_SUCCESS";
export const AUTH_GET_USER_FAIL = "AUTH_GET_USER_FAIL";

export const AUTH_LOGOUT = "AUTH_LOGOUT";



// WEBPACK FOOTER //
// ./src/system/store/auth/types.js